import { render, staticRenderFns } from "./CustomerHubMembershipCard.vue?vue&type=template&id=1ba1606d&scoped=true"
import script from "./CustomerHubMembershipCard.vue?vue&type=script&lang=js"
export * from "./CustomerHubMembershipCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubMembershipCard.vue?vue&type=style&index=0&id=1ba1606d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba1606d",
  null
  
)

export default component.exports